import React from 'react';

const Index = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z" stroke="#EEEEEE"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M26 19.5L24.3696 18L18 24L24.3696 30L26 28.5L21.2 24L26 19.5Z" fill="#008060"/>
      </svg>
    </>
  );
};

export default Index;